const WARM_PARALLEL = 4;

const snapshotImages = new Set<string>();
const warmQueue: string[] = [];
let warming = 0;

const requestCors = (image: HTMLImageElement, url: unknown) => {
	if (typeof url === "string" && snapshotImages.has(url) && image.crossOrigin === null) image.crossOrigin = "anonymous";
};

export const corsForSnapshotImages = () => {
	const descriptor = Object.getOwnPropertyDescriptor(HTMLImageElement.prototype, "src");
	const set = descriptor?.set;
	if (!descriptor || !set) return;
	Object.defineProperty(HTMLImageElement.prototype, "src", {
		...descriptor,
		set(this: HTMLImageElement, url: string) {
			requestCors(this, url);
			set.call(this, url);
		},
	});
	const setAttribute = Element.prototype.setAttribute;
	Element.prototype.setAttribute = function (this: Element, name: string, value: string) {
		if (this instanceof HTMLImageElement && name.toLowerCase() === "src") requestCors(this, value);
		return setAttribute.call(this, name, value);
	};
};

const warmNext = () => {
	const url = warmQueue.shift();
	if (!url) return;
	warming++;
	const image = new Image();
	image.onload = image.onerror = () => {
		warming--;
		warmNext();
	};
	image.src = url;
};

export const warmImages = (urls: unknown) => {
	if (!Array.isArray(urls)) return;
	for (const url of urls) {
		if (typeof url !== "string" || snapshotImages.has(url)) continue;
		snapshotImages.add(url);
		warmQueue.push(url);
	}
	while (warming < WARM_PARALLEL && warmQueue.length) warmNext();
};
